import React from "react"

import styles from "./leftSidebarProfile.module.scss"
//import userDefault from "../../../assets/images/users/default-user-image1.png"

import { Card, Row,Col } from "reactstrap";

const LeftSidebarProfile = (props) => {
    const contactos = props.contactos;

   
    return (
        <React.Fragment>
            {contactos && contactos.map((item,idx) => (
                    <div className="p-2" key ={idx}>
                        <Card className={styles.card}>
                        <Row>
                         {/* <Col lg={3}>
                            <img 
                              src={contactos.image ? contactos.image : userDefault} 
                              alt="" 
                              className="avatar-lg img-thumbnail rounded-circle mb-3" 
                              />
                          </Col>
                          */}

                        <Col className="text-center" lg={12}>
                            
                            <h4 className="text-primary">{item.nombre ? item.get_full_name :  item.razon_social} </h4>

                        </Col>
                      </Row>
                        </Card>
                    </div>
   ))}

        </React.Fragment>
    );
}

export default LeftSidebarProfile;